var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sponsor text-center",attrs:{"id":"sponsor"}},[_c('h2',{staticClass:"p-2"},[_vm._v("Sponsor")])])])}]

export { render, staticRenderFns }